<template>
  <div style="padding:20px 30px">
    <flow-instance
      :request="request"
      :design-form-url="designFormUrl"
      :base-url="baseUrl"
      :token="token"
      :page-size="pageSize"
    ></flow-instance>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import configR from '@/configs.js';
export default {
  computed: {
    ...mapGetters(["serveUrl", "token", "request"]),
    baseUrl() {
      return configR.envConfigs.FORMFLOW_API_URL;
    },
    designFormUrl() {
      return configR.envConfigs.FORMFLOW_DESIGN_API_URL;
    },
  },
  data() {
    return {
      pageSize: 12,
    };
  },
  mounted() {
    this.setPageSize();
    window.addEventListener("resize", () => {
      this.setPageSize();
    });
  },
  methods: {
    setPageSize() {
      this.ready = false;
      this.$nextTick(() => {
        let node = document.getElementById("business-center-container");
        let height = node.offsetHeight - 200;
        this.pageSize = Math.floor(height / 40);
        this.ready = true;
      });
    },
  },
};
</script>
